import { type IAgentChatRoomQuery } from 'application/querySchemas/IAgentChatRoomQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentChatRoomListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAgentChatRoomListClient';
import {
    type IAgentChatMessagesClient,
    IGetResponse as IAgentChatMessagesResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentChatRoomQuery implements IAgentChatRoomQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentChatRoomListClient')
        public readonly agentChatRoomListClient: IAgentChatRoomListClient,
        @inject('IAgentChatMessagesClient')
        public readonly agentChatMessagesClient: IAgentChatMessagesClient,
    ) {}

    public async fetchRoomList(companyName?: string): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentChatRoomListClient.get({
            token: this.agentUserToken.get() || '',
            companyName,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchMessages(chatRoomId: number): Promise<IAgentChatMessagesResponse['data']> {
        const { data, message } = await this.agentChatMessagesClient.get({
            token: this.agentUserToken.get() || '',
            chatRoomId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
